import { useFileSuspense } from "@/shared/domain/files/hooks";

import {
  DownloadFileButton,
  OpenFileInNewTabButton,
  ViewFileDetailsButton,
} from "./controls";
import styles from "./FileActions.module.css";

interface FileActionsProps {
  /** The active fileId */
  fileId: string;
}

/**
 * UI for actions available for the current file
 */
export function FileActions(props: FileActionsProps) {
  const fileQuery = useFileSuspense(props.fileId);

  return (
    <div className={styles.actions}>
      <ViewFileDetailsButton fileRecord={fileQuery.data} />
      <DownloadFileButton fileRecord={fileQuery.data} />
      <OpenFileInNewTabButton fileRecord={fileQuery.data} />
    </div>
  );
}
